import React from 'react';
import { Phone, MessageSquare, Mail, MapPin, Clock } from 'lucide-react';
import { CONTACT } from '../mock';
import logo from '../assets/collins_logo.png';

const Contact = () => {
  const smsHref = `sms:+1${CONTACT.phone}?&body=${CONTACT.smsBody}`;
  return (
    <>
      <section id="contact" className="bg-app py-24 border-t border-white/5">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center">
          <span className="text-xs tracking-[0.3em] text-sky-400 uppercase font-semibold">Get in Touch</span>
          <h2 className="mt-3 font-cond font-700 text-4xl md:text-5xl text-white">Tell Us What's Broken</h2>
          <p className="mt-4 text-gray-400">
            Reach out by phone, text, or email and we'll get back to you fast.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={`tel:+1${CONTACT.phone}`} className="btn-blue px-6 py-3.5 rounded-md font-semibold flex items-center gap-2 w-full sm:w-auto justify-center">
              <Phone className="w-4 h-4" /> Call Now
            </a>
            <a href={smsHref} className="btn-dark px-6 py-3.5 rounded-md font-semibold flex items-center gap-2 w-full sm:w-auto justify-center">
              <MessageSquare className="w-4 h-4" /> Text Us
            </a>
            <a href={`mailto:${CONTACT.email}`} className="btn-dark px-6 py-3.5 rounded-md font-semibold flex items-center gap-2 w-full sm:w-auto justify-center">
              <Mail className="w-4 h-4" /> Email Us
            </a>
          </div>

          <div className="mt-10 grid sm:grid-cols-2 gap-4 text-left">
            <div className="card-dark rounded-xl p-5 flex items-start gap-3">
              <span className="w-9 h-9 rounded-lg bg-sky-500/15 flex items-center justify-center shrink-0">
                <MapPin className="w-4 h-4 text-sky-400" />
              </span>
              <div>
                <h3 className="font-cond font-600 text-white text-sm tracking-wide uppercase">Service Area</h3>
                <p className="mt-1 text-sm text-gray-400">{CONTACT.serviceArea}</p>
              </div>
            </div>
            <div className="card-dark rounded-xl p-5 flex items-start gap-3">
              <span className="w-9 h-9 rounded-lg bg-sky-500/15 flex items-center justify-center shrink-0">
                <Clock className="w-4 h-4 text-sky-400" />
              </span>
              <div>
                <h3 className="font-cond font-600 text-white text-sm tracking-wide uppercase">Hours</h3>
                <ul className="mt-1 space-y-0.5">
                  {CONTACT.hours.map((h) => (
                    <li key={h.days} className="text-sm text-gray-400">
                      <span className="text-gray-200 font-medium">{h.days}:</span> {h.time}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <p className="mt-8 text-sm text-gray-500">
            {CONTACT.phoneDisplay} · <a href={`mailto:${CONTACT.email}`} className="text-sky-400 hover:underline">{CONTACT.email}</a>
          </p>
        </div>
      </section>

      <footer className="bg-[#06070a] border-t border-white/10 py-10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Collins Technologiez LLC" className="h-10 w-auto object-contain" />
            <span className="font-cond font-700 text-white text-sm tracking-wide">
              COLLINS <span className="text-sky-400">TECHNOLOGIEZ</span> LLC
            </span>
          </div>
          <p className="text-sm text-gray-500">© {new Date().getFullYear()} Collins Technologiez LLC. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Contact;
